import { render, staticRenderFns } from "./ServerManagement.vue?vue&type=template&id=0b033df6&"
import script from "./ServerManagement.vue?vue&type=script&lang=js&"
export * from "./ServerManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports